module.exports = __webpack_public_path__ + "img/dfrobot.49af52e9.png";